import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

import home from "../pro-home.module.css";
import { SoonControl } from "../Soon";
import classes from "./simple-sections.module.css";

/** An integration the app has no connection for yet: its card, and Connect Coming soon. */
function SoonIntegration({ name, line }: { name: string; line: string }) {
  return (
    <article className={classes.integration} aria-label={name}>
      <h3 className={classes.integrationName}>{name}</h3>
      <span className={classes.tileLine}>{line}</span>
      <SoonControl className={home.smallButton} label={`Connect ${name}`}>
        Connect
      </SoonControl>
    </article>
  );
}

/**
 * Brand's Integrations (spec ui-perf/simple-brand-tabs): the prototype's three, in its order and
 * words. Meta and Google Ads are the ads area's, not built; AI tools open the MCP Server page,
 * where a terminal tool's token is made and Claude.ai and ChatGPT connect.
 */
export function SimpleIntegrations({ teamId }: { teamId: string }) {
  const name = "AI tools (MCP)";
  return (
    <section aria-label="Integrations" className={classes.integrations}>
      <SoonIntegration name="Meta" line="Publish ads and see results" />
      <SoonIntegration name="Google Ads" line="See results" />
      <article className={classes.integration} aria-label={name}>
        <h3 className={classes.integrationName}>{name}</h3>
        <span className={classes.tileLine}>Use Created AI from Claude, ChatGPT or Codex</span>
        <Link to="/teams/$teamId/mcp-server" params={{ teamId }} className={`${home.smallButton} ${classes.withArrow}`}>
          Connect your AI tool <ArrowRight size={14} aria-hidden />
        </Link>
      </article>
    </section>
  );
}
